import { insertLoginsOrdersReport, insertLoginsOrdersReportExcel, insertAuthorizedClient, insertUserLogs } from '../../api/logins-and-orders-report';
import { LoginOrdersfileDownload } from '@/utilities/loginsAndOrdersFileDownload.js';

const loginsAndOrdersReport = {
  namespaced: true,
  state: () => ({
    sDate: null,
    eDate: null,
    form: {
      is_report_order_type: false,
      start_date: '',
      end_date: '',
      is_all_clients_selected: true,
      client_ids: [],
      platform_types: ['Desktop'],
      first_name: '',
      last_name: '',
      email: '',
      export_to_excel: false,
    },
    loginsAndOrders: {},
    authorizedClients: [],
  }),

  getters: {
    getLoginsOrdersReport: (state) => {
      return state.loginsAndOrders;
    },
    getAuthorizedClients: (state) => {
      return state.authorizedClients;
    },
  },

  actions: {
    addLoginsOrdersReport({ commit }, { form, params }) {
      return new Promise((resolve, reject) => {
        insertLoginsOrdersReport(form, params)
          .then((resp) => {
            if (resp.headers['content-type'] === 'application/json; charset=utf-8') {
              commit('SET_LOGINS_ORDERS_REPORT', resp.data);
            }
            resolve(resp.data);
          })
          .catch((err) => {
            console.log('error from add login order report action');
            reject(err);
          });
      });
    },
    addLoginsOrdersReportExcel({ commit }, form) {
      return new Promise((resolve, reject) => {
        insertLoginsOrdersReportExcel(form)
          .then((resp) => {
            LoginOrdersfileDownload(resp.data);
            resolve(resp.data);
          })
          .catch(() => {
            console.log('error from add login order report action');
          });
      });
    },
    fetchAuthorizedClients({ commit }) {
      return new Promise((resolve, reject) => {
        insertAuthorizedClient()
          .then((resp) => {
            commit('SET_AUTHORIZED_CLIENT', resp.data);
            resolve(resp.data);
          })
          .catch(() => {
            console.log('error from add authorized client action');
          });
      });
    },

    setStartDate({ commit }, date) {
      commit('SET_START_DATE', date);
    },
    setEndDate({ commit }, date) {
      commit('SET_END_DATE', date);
    },

    insertUserLogs({ commit }) {
      const params = {
        platformVersion: 1,
        platform: 'Desktop',
      };

      return new Promise((resolve, reject) => {
        insertUserLogs(params)
          .then((resp) => {
            resolve(resp.data);
          })
          .catch(() => {
            console.log('error from insertUserLogs');
          });
      });
    },
  },

  mutations: {
    SET_LOGINS_ORDERS_REPORT: (state, loginsAndOrders) => {
      state.loginsAndOrders = loginsAndOrders;
    },
    SET_AUTHORIZED_CLIENT: (state, authorizedClients) => {
      state.authorizedClients = authorizedClients;
    },
    SET_START_DATE: (state, date) => {
      state.sDate = date;
    },
    SET_END_DATE: (state, date) => {
      state.eDate = date;
    },
  },
};

export default loginsAndOrdersReport;
